import "./styles/style.less";
import {Flex} from "antd";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";
import Step5 from "./steps/Step5";
import Step6 from "./steps/Step6";
import Step7 from "./steps/Step7";
import Step8 from "./steps/Step8";
import Step9 from "./steps/Step9";
import Step11 from "./steps/Step11";
import Step12 from "./steps/Step12";
import Stepper from "./component/stepper/Stepper";
import Step14 from "./steps/Step14";
import Step15 from "./steps/Step15";

interface Step {
    title: string;
    content: React.ReactNode;
}

export default function AdmissionSteps() {

    const stepsConfig: Step[] = [
        {title: 'Выбор конкурсных групп', content: <Step2 title={"Я поступаю на следующие специальности"}/>},
        {title: 'Расстановка приоритетов', content: <Step3/>},
        {title: 'Персональные данные', content: <Step5/>},
        {title: 'Текущий уровень образования', content: <Step6/>},
        {title: 'Выбор категории абитуриента', content: <Step7/>},
        {title: 'Индвидуальные достижения', content: <Step8/>},
        {title: 'Загрузка дополнительной информации', content: <Step9/>},
        {title: 'Заключение договора', content: <Step11/>},
        {title: 'Запись на внутренние вступительные испытания', content: <Step12/>},
        {title: 'Ознакомление и согласие', content: <Step14/>},
        {title: 'Итог', content: <Step15/>},
    ];

    return (
        <Flex className={"admission-page"} vertical={true} align={"stretch"} gap={16}>
            <Stepper steps={stepsConfig}/>
        </Flex>
    )
}